import { Component, OnInit } from '@angular/core';
import { AuthService, LayoutService, RoleService } from '@d-services';
import { getCurrentPermission } from '@d-store/app-config/app-config.selector';
import { AppState } from '@d-store/constant';
import { select, Store } from '@ngrx/store';
import { first } from 'rxjs';

@Component({
  selector: 'app-master-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class MasterLayoutComponent implements OnInit {
  isLoading = true;
  constructor(
    public layoutService: LayoutService,
    private authService: AuthService,
    private roleService: RoleService,
    private store: Store<AppState>,
  ) {}

  get containerClass() {
    return {
      'layout-theme-light': this.layoutService.config.colorScheme === 'light',
      'layout-theme-dark': this.layoutService.config.colorScheme === 'dark',
      'layout-overlay': this.layoutService.config.menuMode === 'overlay',
      'layout-static': this.layoutService.config.menuMode === 'static',
      'layout-slim': this.layoutService.config.menuMode === 'slim',
      'layout-horizontal': this.layoutService.config.menuMode === 'horizontal',
      'layout-static-inactive':
        this.layoutService.state.staticMenuDesktopInactive &&
        this.layoutService.config.menuMode === 'static',
      'layout-overlay-active': this.layoutService.state.overlayMenuActive,
      'layout-mobile-active': this.layoutService.state.staticMenuMobileActive,
      'p-input-filled': this.layoutService.config.inputStyle === 'filled',
      'p-ripple-disabled': !this.layoutService.config.ripple,
    };
  }

  ngOnInit(): void {
    this.authService.getCurrentUser().subscribe((userInfo) => {
      if (userInfo) {
        this.store
          .pipe(
            select(getCurrentPermission),
            first((val) => !!val),
          )
          .subscribe((_) => {
            this.isLoading = false;
          });
      }
    });
  }
}
